import type React from "react"

import { Box } from "@mui/material"

interface PageHeaderNavigationProps {
  children?: React.ReactNode
}

/**
 * Used to display tab navigation below the page header.
 * Renders as a sticky bar positioned directly under the PageHeader.
 */
export const PageHeaderNavigation: React.FC<PageHeaderNavigationProps> = ({
  children,
}) => {
  return (
    <Box
      sx={{
        bgcolor: "common.white",
        borderBottom: 1,
        borderColor: "divider",
        position: "sticky",
        top: 77,
        zIndex: "appBar",
      }}
    >
      {children}
    </Box>
  )
}
